export const SET_TOKEN = 'SET_TOKEN'
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
export const SET_ACCOUNTS = 'SET_ACCOUNTS'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_RESOURCES = 'SET_RESOURCES'
export const SET_BASTIONS = 'SET_BASTIONS'
export const SET_BASTION = 'SET_BASTION'
export const SET_SSHKEYS = 'SET_SSHKEYS'